import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Activity } from "lucide-react";
import { api } from "@/lib/api";
import { useChat } from "@/lib/chat";
import { analytics } from "@/lib/analytics";

export const healthLabel = (s) => {
  if (!s || s.overall === "unknown") return "Checking systems…";
  if (s.overall === "operational") return "All systems operational";
  const names = [...(s.down || []), ...(s.degraded || [])];
  const list = names.length > 2 ? `${names.slice(0, 2).join(", ")} +${names.length - 2}` : names.join(", ");
  return `${s.overall === "down" ? "Outage" : "Degraded"}: ${list}`;
};

export const HealthPill = () => {
  const { me } = useChat();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const isAdmin = !!me?.is_admin;
  useEffect(() => {
    if (!isAdmin) return;
    let alive = true;
    const load = () => api.get("/health/status").then((r) => alive && setStatus(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    const onPush = (e) => setStatus(e.detail);
    window.addEventListener("tc:health", onPush);
    return () => { alive = false; clearInterval(iv); window.removeEventListener("tc:health", onPush); };
  }, [isAdmin]);
  if (!isAdmin) return null;
  const level = status?.overall || "unknown";
  return (
    <button className={`tc-health-pill is-${level}`} title={healthLabel(status)} onClick={() => { analytics.track("health_pill_clicked", { category: "navigation", label: level }); navigate("/admin/health"); }} data-testid="health-pill" data-status={level}>
      <span className="tc-health-pill__dot" />
      <Activity size={13} />
      <span data-testid="health-pill-label">{healthLabel(status)}</span>
    </button>
  );
};
